import { clearMessageFiles } from "../libs/fileHandler";
import { ChatClearMessageResponse } from "../proto/ChatClearMessage_pb";
import { GroupClearMessageResponse } from "../proto/GroupClearMessage_pb";
import store from "../store";
import { clearRoomMessages } from "../store/messages/actions";
import BaseHandler from "./BaseHandler";

export default class HandleRoomClearMessageResponse extends BaseHandler<ChatClearMessageResponse | GroupClearMessageResponse> {
  handle() {
    const roomClearMessageResponse = this.response.toObject();
    store.dispatch(
      clearRoomMessages({
        roomId: roomClearMessageResponse.roomId,
        clearId: roomClearMessageResponse.clearId,
      })
    );
    const roomMessages = store.getState().messages.roomMessages[roomClearMessageResponse.roomId];
    roomMessages?.forEach((messageId) => {
      if (messageId <= roomClearMessageResponse.clearId) {
        clearMessageFiles(messageId);
      }
    });
  }
}
